import React from 'react';
import Image from 'next/image';

import styles from './FooterWorker.module.scss';
import { LOGO, RRSS } from '../../utils/assets';

const socialNetworks = [
  {
    icon: RRSS.FACEBOOK,
    url: 'https://www.facebook.com/bicevida',
    alt: 'Logo Facebook',
  },
  {
    icon: RRSS.INSTAGRAM,
    url: 'https://instagram.com/bicevida?igshid=1hvwy2nj0rlzk',
    alt: 'Logo Instagram',
  },
  {
    icon: RRSS.X,
    url: 'https://twitter.com/bice_vida',
    alt: 'Logo X',
  },
  {
    icon: RRSS.YOUTUBE,
    url: 'https://www.youtube.com/channel/UCNzbIUVP0ckWGuJ3yFgzsYw',
    alt: 'Logo YouTube',
  },
];

const FooterWorker: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footer_line}>
        <div className={styles.footer_line_primary} />
        <div className={styles.footer_line_secondary} />
      </div>

      <div className={styles.footer_content}>
        <div className={styles.footer_logo}>
          <Image
            src={LOGO.COLOR}
            alt="BICEVIDA"
            width={119}
            height={15}
            onClick={() => window.open('https://www.bicevida.cl', '_blank')}
            className={styles.logo_img}
          />
        </div>

        <div className={styles.footer_center}>
          <span className={styles.footer_service}>
            Servicio al cliente{' '}
            <a href="tel:8002020 22" className={styles.footer_phone}>
              800 2020 22
            </a>
          </span>
          <div className={styles.footer_copyright_container}>
            <span className={styles.footer_copyright}>Copyright © {currentYear} BICE VIDA</span>
            <span className={styles.footer_copyright_separator}> - </span>
            <span className={styles.footer_copyright}>Todos los derechos reservados</span>
          </div>
        </div>

        <div className={styles.footer_social}>
          {socialNetworks.map((network, index) => (
            <Image
              key={`footer_social_${index}`}
              src={network.icon}
              alt={network.alt}
              width={20}
              height={20}
              onClick={() => window.open(network.url, '_blank')}
              className={styles.social_icon}
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default FooterWorker;
